__turbopack_context__.v({
  "fadeInItems": "WordpressLink-module__bKGh9G__fadeInItems",
  "spacing--lg": "WordpressLink-module__bKGh9G__spacing--lg",
  "spacing--md": "WordpressLink-module__bKGh9G__spacing--md",
  "spacing--sm": "WordpressLink-module__bKGh9G__spacing--sm",
  "spacing--xl": "WordpressLink-module__bKGh9G__spacing--xl",
  "spacing--xs": "WordpressLink-module__bKGh9G__spacing--xs",
  "spacing--xxl": "WordpressLink-module__bKGh9G__spacing--xxl",
  "spacing--xxs": "WordpressLink-module__bKGh9G__spacing--xxs",
  "spacing--xxxl": "WordpressLink-module__bKGh9G__spacing--xxxl",
  "spacing--xxxs": "WordpressLink-module__bKGh9G__spacing--xxxs",
});
